import type {AiPromptBox} from '@Components/ai-prompt-box/ai-prompt-box.types';
import type {UseAiPromptBox} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import {useAiPromptBox} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import {useGetTeamCredits} from '@Hooks/useGetTeamCredits';
import {useHandlePromptBoxCreditsPillVisibility} from '@Components/ai-prompt-box/hooks/useHandlePromptBoxCreditsPillVisibility';

export interface UseInitAiPromptBox {
  aiPromptBox: UseAiPromptBox;
  fetchedCredits: number | undefined | null;
}

export const useInitAiPromptBox = (promptBoxId: string, initialConfig?: Partial<AiPromptBox>): UseInitAiPromptBox => {
  const promptBox = useAiPromptBox(promptBoxId, initialConfig);
  const fetchedCredits = useGetTeamCredits();
  useHandlePromptBoxCreditsPillVisibility(promptBox.state, promptBox.actions, fetchedCredits);

  return {
    aiPromptBox: promptBox,
    fetchedCredits,
  }
}